import { OP_LABELS } from './blockChangeHelpers'

function targetLabel(card) {
  if (card.target_id) return ` #${card.target_id}`
  if (card.target_temp_ref) return ` new row ${card.target_temp_ref}`
  return ''
}

export function diffCardTitle(card) {
  const target = targetLabel(card)
  const created = card.temp_ref ? ` (new row ${card.temp_ref})` : ''
  return `${OP_LABELS[card.op] ?? card.op} ${card.table}${target}${created}`
}
